import { useCallback } from 'react';
import { useNotifications } from '@client/foundation/notifications/notifications.hook';
import { useTemplateMutations } from '../template-mutations.hook';
import { templateNotifications } from '../template-notifications';

const getErrorMessage = (error: unknown): string | undefined => {
  if (error instanceof Error && error.message.length > 0) {
    return error.message;
  }

  return undefined;
};

export const useDeleteTemplates = () => {
  const { deleteTemplates } = useTemplateMutations();
  const { notify } = useNotifications();

  const onDelete = useCallback(
    async (templateIds: string[]) => {
      try {
        const count = await deleteTemplates({ templateIds });

        if (count !== undefined) {
          const isSuccess = count > 0;
          const message =
            count > 0 ? templateNotifications.deleted(count) : templateNotifications.deleteFailed();

          notify({
            type: isSuccess ? 'success' : 'error',
            message
          });
        }

        return count;
      } catch (error) {
        notify({
          type: 'error',
          message: getErrorMessage(error) ?? templateNotifications.deleteFailed()
        });
        return 0;
      }
    },
    [deleteTemplates, notify]
  );

  return { onDelete };
};
